const amplifyConfigs = {
  aws_project_region: "us-west-2",
  aws_user_pools_id: "us-west-2_PswWRNJea",
  aws_user_pools_web_client_id: "3r3jr6c8v4u6jjjos8fl19vrtv",
};

export default amplifyConfigs;
